module.exports = __webpack_public_path__ + "static/media/Huan Deng.887ebf60.png";